import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="page-404" className="min-h-[70vh] flex items-center justify-center bg-white">
      <div className="max-w-2xl mx-auto px-6 text-center">
        <div className="oh-label-pill mx-auto">Error · 404</div>
        <h1 className="mt-6 text-5xl lg:text-7xl font-display font-black text-[#1F1F1F] leading-[1.05]">Off the network.</h1>
        <p className="mt-5 text-neutral-600">The page you’re looking for isn’t part of OneHill’s operating map.</p>
        <Link
          to="/"
          data-testid="404-cta-home"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#99CC00] text-[#1F1F1F] px-7 py-3.5 text-sm font-black hover:bg-[#B5E000] transition-colors"
        >
          Back to home <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
